import { useEffect, useState } from "react";
import EventInfo, { EventInfoType } from "./EventInfo/EventInfo";

const EventsSection = () => {
  const [events, setEvents] = useState<EventInfoType[]>([]);

  useEffect(() => {
    fetch("./Events.json")
      .then((resp) => resp.json())
      .then((json) => setEvents(json));
  }, []);

  return (
    <>
      <div>
        <h1>EVENTS</h1>
        <p>
          You are invited to attend the following events! Dress code is
          party/wedding casual, come in whatever is comfortable (We don't care
          what you wear!).
        </p>
        <p>
          We will not be serving a "lunch time" meal, so please plan
          accordingly. However, in the evening we will be serving a hog roast
          and a meat free alternative.
        </p>
        {events.map((event) => (
          <EventInfo EventsSection={event} />
        ))}
      </div>
      <div>
        <h2>BOOKING A STAY</h2>
        <p>
          A discounted rate of £65 has been agreed at the Holiday Inn Express in
          Kettering.
        </p>
        <p>
          To book a room with a breakfast click{" "}
          <a href="https://www.ihg.com/redirect?path=rates&brandCode=EX&regionCode=1&localeCode=en&checkInMonthYear=022027&checkInDate=13&checkOutDate=14&checkOutMonthYear=022027&hotelCode=ORMKP&GPC=OVA&numberOfAdults=1&numberOfRooms=1&adjustMonth=false&showApp=true&monthIndex=00">
            here!
          </a>
        </p>
      </div>
    </>
  );
};

export default EventsSection;
